// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__29JXp","footer":"ModalUpdate_footer__yzuOi"};